import React, { ReactElement } from 'react';
import {
  SortLink, Table, Tbody, Td, Th, Thead, Tr, usePerPageValueFromUrl,
} from 'idsk-react-components';
import { MobilePerPageSelect, Pagination, useResponsiveContext } from 'slovlex-idsk-react-components';
import { useSearchParams } from 'react-router-dom';
import './notifikaciaHistoriaListTable.scss';
import NotifikaciaHistoriaPage from '../../../../model/notifikacia/NotifikaciaHistoriaPage';
import { perPageDataArray } from '../../../../constants/PaginationPerPageConstants';
import dateTimeToString from '../../../../function/dateTimeToString';

interface Props {
  notifikaciaHistoriaPage: NotifikaciaHistoriaPage | undefined,
}

const NotifikaciaHistoriaListTable = ({
  notifikaciaHistoriaPage,
}: Props): ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray);
  const { isSmallScreen } = useResponsiveContext();

  if (!notifikaciaHistoriaPage) {
    return <></>;
  }

  if (notifikaciaHistoriaPage.totalElements === 0) {
    return <p className="text-center">Nenašli sa žiadne záznamy.</p>;
  }

  return (
    <div className="notifikacia-list-table">
      {isSmallScreen && (
        <MobilePerPageSelect
          onRecordsPerPageChange={(value) => {
            const updatedSearchParams = new URLSearchParams(searchParams.toString());
            updatedSearchParams.set('perPage', value.toString());
            setSearchParams(updatedSearchParams.toString());
          }}
          recordsPerPage={perPageDataArray}
          perPageValue={perPageValue}
        />
      )}
      <Table>
        <Thead>
          <Tr>
            <Th width="40%">
              <SortLink
                propertyName="datumOdoslania"
                directionOfDefaultSort="desc"
                defaultDirection="desc"
                linkColor="black"
              >Dátum a čas odoslania notifikácie
              </SortLink>
            </Th>
            <Th>Typ notifikácie</Th>
          </Tr>
        </Thead>
        <Tbody>
          {notifikaciaHistoriaPage.notifikaciaHistoriaList.map((notifikacia) => (
            <Tr key={notifikacia.uuid}>
              <Td>{dateTimeToString(notifikacia.datumOdoslania)}</Td>
              <Td>{notifikacia.typ}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <Pagination
        number={notifikaciaHistoriaPage.number}
        size={notifikaciaHistoriaPage.size}
        totalElements={notifikaciaHistoriaPage.totalElements}
        onRecordsPerPageChange={(value) => {
          const updatedSearchParams = new URLSearchParams(searchParams.toString());
          updatedSearchParams.set('perPage', value.toString());
          setSearchParams(updatedSearchParams.toString());
        }}
        recordsPerPage={perPageDataArray}
        perPageValue={perPageValue}
        hideTotal
      />
    </div>
  );
};

export default NotifikaciaHistoriaListTable;
